<div *transloco="let t">
	<ng-container class="flex flex-col">
		<div class="flex flex-col justify-evenly items-start">
			@for (deviceConsumptionSummary of summedEnergy; track deviceConsumptionSummary) {
				<div class="ml-2 mt-4">
					<div style="font-weight: bolder">
						{{ t('enum.' + deviceConsumptionSummary.deviceType) }}
						({{ t('enum.' + deviceConsumptionSummary.deviceType + '_long') }})
					</div>
				</div>
				<div class="ml-4 mt-4">
					<div style="font-weight: bold">
						{{ t('uviPercentage.energyConsumedSummedInfoDialog') }}
					</div>
					<div>
						{{ numberUtil.scaleAndReplaceDot(deviceConsumptionSummary.consumption, 2) }}
						{{ t('enum.' + (deviceConsumptionSummary.consumptionUnit ?? 'UNITS')) }}
					</div>
				</div>
				<div class="ml-4 mt-4">
					<div style="font-weight: bold">
						{{ t('uviPercentage.energyConsumedkWh') }}
					</div>
					<div>{{ numberUtil.scaleAndReplaceDot(deviceConsumptionSummary.consumptionAsKwh) }} {{ t('enum.KWH') }}</div>
				</div>
				<div class="ml-4 mt-4">
					<div style="font-weight: bold; font-size: small">
						{{ t('uviPercentage.calculationDetails') }}
					</div>
					<div style="font-size: smaller">
						{{ formulaUtil.translateFormulaDescription(deviceConsumptionSummary.consumptionKwhFormula.formulaDescription) }}
					</div>
					<div>
						{{ formulaUtil.translateFormula(deviceConsumptionSummary) }}
					</div>
				</div>
			}
		</div>
		<div class="flex flex-row justify-end items-center">
			<button (click)="close()" class="m-2" mat-raised-button name="buttonClose" type="button">
				<mat-icon>cancel</mat-icon>
				<span>
					{{ t('commonActions.close') }}
				</span>
			</button>
		</div>
	</ng-container>
</div>
